'use client';

import { useQuery } from '@tanstack/react-query';

import * as userService from '@/services/user';

export function useUserInfo() {
  return useQuery({
    queryKey: ['userInfo'],
    queryFn: () => userService.getUserInfo(),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
  });
}
